import LoginView from "@/views/LoginView.vue";
import LogoutView from "@/views/LogoutView.vue";
import { CustomRouteConfig } from "@/models/plugins/CustomRouterTypes";
import AboutView from "@/views/AboutView.vue";
import EnableDelayView from "@/views/debug/EnableDelayView.vue";
import DisableDelayView from "@/views/debug/DisableDelayView.vue";
import IconsView from "@/views/debug/IconsView.vue";

const GeneralRoutes: Array<CustomRouteConfig> = [
  {
    name: "Login",
    path: "login/:redirect?",
    component: LoginView,
    meta: { isAnonymousAccess: true },
  },
  {
    name: "Logout",
    path: "logout",
    component: LogoutView,
  },
  {
    name: "Remind Password",
    path: "/remind-password",
    meta: { isAnonymousAccess: true, skipOfficeInUrl: true },
    component: () => import(/* webpackChunkName: "remind-password" */ "@/views/RemindPasswordView.vue"),
  },
  {
    name: "Remind Password With Office",
    path: "remind-password",
    meta: { isAnonymousAccess: true },
    component: () => import(/* webpackChunkName: "remind-password" */ "@/views/RemindPasswordView.vue"),
  },
  {
    name: "Reset Password",
    path: "/reset-password",
    meta: { isAnonymousAccess: true, skipOfficeInUrl: true },
    component: () => import(/* webpackChunkName: "reset-password" */ "@/views/ResetPasswordView.vue"),
  },
  {
    name: "Insufficient Permissions",
    path: "insufficient-permissions",
    component: () =>
      import(/* webpackChunkName: "insufficient-permissions" */ "@/views/InsufficientPermissionsView.vue"),
  },
  {
    name: "About",
    path: "about",
    component: AboutView,
  },
];

if (process.env.NODE_ENV === "development") {
  GeneralRoutes.push({
    name: "Icons",
    path: "icons",
    component: IconsView,
  });
}

if (/true/i.test(process.env.VUE_APP_DELAY_FUNCTIONALITY ?? "")) {
  GeneralRoutes.push({
    name: "Enable delay",
    path: "debug/enable-delay/:i?",
    component: EnableDelayView,
  });
  GeneralRoutes.push({
    name: "Disable delay",
    path: "debug/disable-delay",
    component: DisableDelayView,
  });
}

export { GeneralRoutes };

export default GeneralRoutes;
